<template>
  <div>
    <list
      ref="refProfileAcademicTrainingList"
      sort-by="PerfilFormacionAcademicaId"
      :refetch-records="fetchProfilesAcademicTraining"
      refetch-records-name="perfilesFormacionesAcademicas"
      :actions="actions"
      key-field="perfilFormacionAcademicaId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteProfileAcademicTraining"
      :filters.sync="filters"
    />>
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refProfileAcademicTrainingList = ref(null)
    /* Services */
    const {
      fetchProfilesAcademicTraining,
      deleteProfileAcademicTraining,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.profileAcademicTraining.columns.name'),
        key: 'perfil.nombre',
      },
      {
        label: i18n.t('humanResources.profileAcademicTraining.columns.academicTraining'),
        key: 'formacionAcademica.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Perfil',
        routeName: 'apps-human-resources-profile-academic-training-edit',
        params: ['perfilFormacionAcademicaId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Perfil',
        params: ['perfilFormacionAcademicaId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-profile-academic-training-add',
        label: i18n.t('Routes.ProfileAcademicTrainingAdd'),
        aclAction: 'create',
        aclResource: 'Perfil',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refProfileAcademicTrainingList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchProfilesAcademicTraining,
      deleteProfileAcademicTraining,
    }
  },
}
</script>
